import { CameraIc, Image, ImageList, SendIc } from "@/components/Elements";
import { InputField, UploadImageField } from "@/components/Form";
import { FileModel, UserModel } from "@/types/common";
import { PropsWithChildren, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { MessageInputSchemaModel } from "../types/schema";

const MessageInput = ({
  model,
  userList: allUserList,
  handleSend,
  children,
  placeholder,
}: PropsWithChildren<{
  model: UseFormReturn<MessageInputSchemaModel>;
  placeholder: string;
  userList: UserModel[];
  handleSend: (values: MessageInputSchemaModel) => void;
}>) => {
  const [state, setState] = useState<{
    showList: boolean;
    userList: UserModel[];
    keywordPosition: number;
  }>({ showList: false, userList: [], keywordPosition: 0 });
  const { showList, userList } = state;
  const { getValues, register, setValue, formState, handleSubmit, reset } =
    model;

  const onCursorChange = (event: any) => {
    const cursorPosition = event.target.selectionStart;
    const value = event.target.value;
    if (value && value.length > 0) {
      let textBeforeCursorPosition =
        value.substring(0, cursorPosition).split(" ").at(-1) ?? "";
      const startIndex = textBeforeCursorPosition
        ? textBeforeCursorPosition.indexOf("@")
        : -1;
      if (startIndex > -1) {
        let userList = allUserList,
          searchBy = textBeforeCursorPosition?.replace("@", "")?.toLowerCase();
        if (searchBy) {
          userList = userList.filter((c) =>
            c.fullName?.toLowerCase().includes(searchBy)
          );
        }
        setState({
          userList,
          showList: userList.length > 0,
          keywordPosition: cursorPosition - textBeforeCursorPosition.length,
        });
        return;
      }
    }
    setState((prev) => ({
      ...prev,
      showList: false,
    }));
    setValue("comment", value);
  };

  const handleSelectUser = (user: UserModel) => {
    const { keywordPosition } = state;
    const value = getValues("comment");
    const endIndex = value.indexOf(" ", keywordPosition);
    const newValue =
      value.substring(0, keywordPosition + 1) +
      user.fullName +
      (endIndex > -1 ? value.substring(endIndex, value.length) : "");
    setState((prev) => ({ ...prev, showList: false }));
    setValue("comment", newValue);
  };

  const files = getValues("files");

  const handleUpload = (name: string, value: any) => {
    setValue("files", [value]);
  };

  const onSend = async (values: MessageInputSchemaModel) => {
    try {
      handleSend(values);
      reset();
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <div className="flex-1 h-[90px]">
        <div className="w-[90%] p-2 absolute bottom-0 z-[2] bg-[#ffffff]">
          {children}
          {showList && (
            <div className="z-10 bg-[#ffffff] w-full border-2 border-[#d3d3d3] mb-2 shadow-[#000] shadow-lg">
              {userList.map((item) => (
                <div
                  key={item.userId}
                  className="p-3"
                  onClick={() => handleSelectUser(item)}
                >
                  <div className="flex flex-1">
                    <div className="rounded-[50px] border border-[#d3d3d3] w-[50px] h-[50px] p-[1px]">
                      <Image
                        src={item.userImageUrl}
                        className="w-full h-full"
                        isApiUrl
                      />
                    </div>
                    <div className="text-[14px] font-bold ml-[10px] self-center">
                      {item.fullName}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="flex justify-between items-center">
            <InputField
              type="text"
              placeholder={placeholder}
              registration={{
                ...register("comment"),
                onChange: async (event) => onCursorChange(event),
              }}
              error={formState.errors["comment"]}
              className="w-full mb-0"
            />
          </div>
          <div>
            <div className="flex justify-between m-1">
              <div>
                <UploadImageField name="file" setValue={handleUpload}>
                  <CameraIc className="h-6 w-6" />
                </UploadImageField>
              </div>
              <div onClick={handleSubmit(onSend)} className="cursor-pointer">
                <SendIc className="h-6 w-6" />
              </div>
            </div>
          </div>
          {files && (
            <ImageList
              files={files}
              handleChange={(value: FileModel[]) => setValue("files", value)}
              showRemove
            />
          )}
        </div>
      </div>
    </>
  );
};

export default MessageInput;
